import React, { Component } from "react";
import {
  TouchableHighlight,
  View,
  Dimensions,
  StyleSheet,
  Platform,
} from "react-native";
import Text from "../../components_v2/TextFont";
import SimpleTimePicker from "../../components_v2/SimpleTimePicker";
import Theme from "../../argon-ui/Theme";
import { translate } from "../../locales/translate";
import InputBase from "../../nativeBase-ui/InputBase";
import Select from "../../nativeBase-ui/Select";
import TabBase from "../../nativeBase-ui/TabBase";
import { HStack } from "native-base";
const { width } = Dimensions.get("screen");
const allDaysOfWeek = [
  "saturday",
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
];
const allIntervalTypes = ["day", "hour", "minute"];
class MainConditionSchedule extends Component {
  constructor(props) {
    super(props);
    let {
      id,
      time,
      repeatType,
      repeatInterval,
      repeatIntervalType,
      daysOfWeek,
    } = this.props;
    let daysOfWeekArray = Array.isArray(daysOfWeek)
      ? daysOfWeek
      : daysOfWeek
      ? daysOfWeek.split(",")
      : [];
    let now = new Date();

    this.state = {
      // showTimePicker: false,
      id,
      repeatType: repeatType || "daily", // either daily or custom
      repeatInterval: repeatInterval || 0,
      repeatIntervalType: repeatIntervalType || allIntervalTypes[0], // one of minute, hour or day. default is first item of list
      _repeatIntervalTypeIndex: repeatIntervalType
        ? Math.max(allIntervalTypes.indexOf(repeatIntervalType), 0) // put 0 if indexOf() returns -1
        : 0,
      daysOfWeek: daysOfWeekArray,
      time: time || `${now.getHours()}:${now.getMinutes()}`,
    };
    this.tabs = ["daily", "custom"];
  }

  componentDidMount() {}

  handleTabChange = (tab) => {
    this.setState({ repeatType: tab }, () => {
      this.props.onRepeatTypeChange && this.props.onRepeatTypeChange(tab);
    });
  };

  handleTimeChange = (time) => {
    this.setState({ time }, () => {
      this.props.onTimeChange && this.props.onTimeChange(time);
    });
  };

  handleToggleDaysOfWeek = (day) => {
    var idx = this.state.daysOfWeek.indexOf(day);
    var newArray = [...this.state.daysOfWeek];
    if (idx >= 0) {
      newArray.splice(idx, 1);
      this.setState({ daysOfWeek: newArray });
    } else {
      newArray.push(day);
      this.setState({ daysOfWeek: newArray });
    }
    this.props.onDaysOfWeeksChange &&
      this.props.onDaysOfWeeksChange(newArray.join());
  };

  handleRepeatIntervalChange = (interval) => {
    this.setState({ repeatInterval: interval }, () =>
      this.handleCustomRepeatChange(interval, this.state.repeatIntervalType)
    );
  };

  handleRepeatIntervalTypeChange = (intervalType) => {
    this.setState(
      {
        repeatIntervalType: intervalType,
      },
      () =>
        this.handleCustomRepeatChange(this.state.repeatInterval, intervalType)
    );
  };

  handleCustomRepeatChange = (interval, intervalType) => {
    this.props.onCustomRepeatChanged &&
      this.props.onCustomRepeatChanged(interval, intervalType);
  };

  renderDayOfWeekButton(day = "", selected = false, onPres = () => {}) {
    return (
      <TouchableHighlight
        key={day}
        style={[
          styles.daysOfWeekContainer,
          selected && styles.activeDaysOfWeek,
        ]}
        underlayColor="#e2e2e2"
        onPress={() => typeof onPres === "function" && onPres()}
      >
        <Text
          style={{
            padding: 5,
            fontSize: day == "everyday" ? 14 : 22,
            color: selected ? Theme.COLORS.ACTIVE : Theme.COLORS.MUTED,
          }}
        >
          {translate(`week.short.${day}`)}
        </Text>
      </TouchableHighlight>
    );
  }

  render() {
    return (
      <View style={this.props.style || {}}>
        {/* time picker */}
        <Text style={{ fontWeight: "bold" }}>
          {translate("scenario.executionTime")}
        </Text>
        <SimpleTimePicker
          value={this.state.time}
          onChange={this.handleTimeChange}
          style={styles.timePicker}
        />

        {/* tabs */}
        <TabBase
          containerStyle={{ marginVertical: 10 }}
          tab={this.state.repeatType.toLowerCase()}
          tabs={this.tabs}
          handleChange={(tab) => this.handleTabChange(tab)}
        >
          {/* repeat daily */}
          {this.state.repeatType.toLowerCase() == "daily" && (
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              {this.renderDayOfWeekButton(
                "everyday",
                this.state.daysOfWeek.length == 0,
                () => {
                  this.setState({ daysOfWeek: [] });
                  this.props.onDaysOfWeeksChange &&
                    this.props.onDaysOfWeeksChange("");
                }
              )}
              {allDaysOfWeek.map((d, i) => {
                return this.renderDayOfWeekButton(
                  d,
                  this.state.daysOfWeek.indexOf(d) >= 0,
                  () => {
                    this.handleToggleDaysOfWeek(d);
                  }
                );
              })}
            </View>
          )}
          {/* custom repeat */}
          {this.state.repeatType.toLowerCase() == "custom" && (
            <HStack space="2" alignItems="center">
              <Text
                style={{ width: 40, fontSize: 15, color: Theme.COLORS.MUTED }}
              >
                {translate("timer.every")}
              </Text>
              <InputBase
                containerStyle={{ width: 155 }}
                inputStyle={{ height: 40, textAlign: "left" }}
                keyboardType="numeric"
                onChangeText={(txt) => this.handleRepeatIntervalChange(txt)}
                value={(this.state.repeatInterval || "").toString()}
              />
              <View style={{ flex: 1 }}>
                <Select
                  data={allIntervalTypes.map((v) => {
                    return { value: v, label: translate(`app.${v}`) };
                  })}
                  value={this.state.repeatIntervalType}
                  onChangeText={(value, index, data) => {
                    this.handleRepeatIntervalTypeChange(value);
                  }}
                />
              </View>
            </HStack>
          )}
        </TabBase>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  // timePicker: { width: width - 96, marginVertical: 5 },
  timePicker: { flex: 1, marginVertical: 5 },
  daysOfWeekContainer: {
    minWidth: 40,
    minHeight: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  activeDaysOfWeek: {
    borderRadius: 5,
    backgroundColor: Theme.COLORS.ACTIVE + 15,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
});

export default MainConditionSchedule;
